import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Typography, Dialog, DialogTitle, DialogContent, Grid, DialogActions, Button, Box } from '@mui/material'
import { WarningRounded } from '@mui/icons-material'
import { SkillBiteEditSlice } from '../../../../reducers'

const SkillBiteConfirmEditMode = ({ open, setOpen }) => {
  const skillBite = useSelector(SkillBiteEditSlice.selectors.selectSkillBite)
  const { name } = skillBite
  const dispatch = useDispatch()

  const handleClose = () => {
    setOpen(false)
  }

  const handleChangeEditMode = () => {
    dispatch(SkillBiteEditSlice.actions.changeEditMode(true))
    setOpen(false)
  }

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      data-test='skill-bite-edit-mode-modal'
      PaperProps={{
        sx: {
          maxWidth: '750px'
        }
      }}
    >
      <DialogTitle
        data-test='skill-bite-edit-mode-modal-title'
        style={{ borderBottom: '1px solid #E0E0E0' }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <Typography
            variant='h6'
            data-test='skill-bite-edit-mode-modal-title'
          >
            Edit a live Skill Bite
          </Typography>
        </Box>
      </DialogTitle>
      <Grid
        container
        direction='column'
      >
        <DialogContent
          data-test='skill-bite-edit-mode-modal-content'
        >
          <Box display='flex' flexDirection='row' justifyContent='space-between' alignItems='flex-start' sx={{ backgroundColor: '#F7EABD', border: '1px solid #f7bdbd', borderRadius: 4, padding: 2 }}>
            <Box>
              <WarningRounded htmlColor='#8C6D01' />
            </Box>
            <Box ml={2}>
              <Typography variant='secondary' color='#8C6D01' sx={{ fontWeight: 600 }}>
                {name} Skill Bite is live.
              </Typography>
              <Typography>
                Changes to your Skill Bites can impact how users experience it and the results you receive.
              </Typography>
            </Box>
          </Box>
          <Box mt={2}>
            <Typography>
              You can edit only the textual content for corrections. The overall structure, including the position of sessions, remains fixed once published.
            </Typography>
            <Typography mt={2}>
              If you are sure you want to edit this Skill Bite, click "Proceed".
            </Typography>
          </Box>
        </DialogContent>
      </Grid>
      <DialogActions>
        <Button
          autoFocus
          color='primary'
          onClick={handleClose}
          data-test='skill-bite-edit-mode-modal-cancel-button'
        >
          Cancel
        </Button>
        <Button
          autoFocus
          color='primary'
          onClick={handleChangeEditMode}
          data-test='skill-bite-edit-mode-modal-proceed-button'
        >
          Proceed
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default SkillBiteConfirmEditMode
